export const AppInstallInFeedBannerPlacements = {
  PERFORMER: "performer",
} as const;

export type AppInstallInFeedBannerPlacement =
  (typeof AppInstallInFeedBannerPlacements)[keyof typeof AppInstallInFeedBannerPlacements];
